import { Injectable } from '@angular/core';
import { FinanceReportsApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { FinanceReportsAction } from '../actions';

@Injectable()
export class FinanceReportsEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(FinanceReportsAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => FinanceReportsAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: FinanceReportsApiService, private _actions$: Actions, private _store: Store) {}
}
